



import Component from 'vue-class-component';

import JournalReportNew from '@/components/reports/JournalReportNew.vue';

import { BaseVue } from '../../BaseVue';
import JournalReport from './JournalReport.vue';

@Component({
  components: {
    JournalReport,
    JournalReportNew,
  },
})
export default class JournalReportWrapper extends BaseVue {}
